export function modalReducer(state: any, action: any) {
  switch (action.type) {
    case "close":
      return { open: false };
    case "open":
      return { open: true, status: action.status };
    case "loading":
      return {
        ...state,
        loading: true,
      };
    case "loaded":
      return {
        ...state,
        loading: false,
      };
    default:
      throw new Error("Unsupported action...");
  }
}
